<div class="accessibility-container" (keydown)="onKeyDown($event)">
  <!-- Botón flotante de accesibilidad -->
  <button 
    class="accessibility-toggle-btn" 
    (click)="toggleAccessibilityPanel()" 
    [attr.aria-expanded]="showAccessibilityPanel" 
    [attr.aria-label]="showAccessibilityPanel ? 'Cerrar opciones de accesibilidad' : 'Abrir opciones de accesibilidad'"
    role="button"
    tabindex="0">
    <i class="fas fa-wheelchair"></i>
  </button>

  <!-- Panel de accesibilidad -->
  <div 
    class="accessibility-panel"
    [class.show]="showAccessibilityPanel"
    role="dialog"
    aria-labelledby="accessibility-title">
    
    <div class="accessibility-header">
      <h3 id="accessibility-title">Configuración de Accesibilidad</h3>
      <button 
        class="close-btn"
        (click)="toggleAccessibilityPanel()"
        aria-label="Cerrar panel de accesibilidad">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="accessibility-content">
      <p>Personaliza la experiencia de navegación según tus necesidades de accesibilidad.</p>
      
      <!-- Contraste -->
      <div class="accessibility-option">
        <label class="accessibility-label">
          <input 
            type="checkbox" 
            [checked]="isHighContrast"
            (change)="toggleHighContrast()">
          Alto Contraste
        </label>
        <p class="option-description">
          Mejora la legibilidad con colores de alto contraste
        </p>
      </div>

      <!-- Tamaño de fuente -->
      <div class="accessibility-option">
        <label class="accessibility-label">Tamaño de Fuente</label>
        <div class="font-controls">
          <button 
            class="font-btn"
            (click)="decreaseFontSize()"
            [disabled]="fontSize <= 12">
            <i class="fas fa-minus"></i>
          </button>
          <span class="font-size-display">{{ fontSize }}px</span>
          <button 
            class="font-btn"
            (click)="increaseFontSize()"
            [disabled]="fontSize >= 24">
            <i class="fas fa-plus"></i>
          </button>
          <button 
            class="font-btn reset-btn"
            (click)="resetFontSize()">
            <i class="fas fa-undo"></i>
          </button>
        </div>
      </div>

      <!-- Movimiento reducido -->
      <div class="accessibility-option">
        <label class="accessibility-label">
          <input 
            type="checkbox" 
            [checked]="isReducedMotion"
            (change)="toggleReducedMotion()">
          Movimiento Reducido
        </label>
        <p class="option-description">
          Reduce las animaciones y movimientos en pantalla
        </p>
      </div>

      <!-- Fuente amigable para dislexia -->
      <div class="accessibility-option">
        <label class="accessibility-label">
          <input 
            type="checkbox" 
            [checked]="isDyslexicFriendly"
            (change)="toggleDyslexicFriendly()">
          Fuente Amigable para Dislexia
        </label>
        <p class="option-description">
          Utiliza tipografías optimizadas para personas con dislexia
        </p>
      </div>

      <!-- Botón de Reset Global -->
      <div class="accessibility-option reset-global-option">
        <button 
          class="reset-global-btn"
          (click)="resetAllAccessibilitySettings()"
          type="button">
          <i class="fas fa-home"></i>
          Restablecer a Valores por Defecto
        </button>
        <p class="option-description">
          Vuelve a la configuración original del sitio
        </p>
      </div>

      <!-- Atajos de teclado -->
      <div class="keyboard-shortcuts">
        <h4>Atajos de Teclado</h4>
        <ul>
          <li><kbd>Tab</kbd> - Navegar entre elementos</li>
          <li><kbd>Enter</kbd> / <kbd>Espacio</kbd> - Activar botones</li>
          <li><kbd>Escape</kbd> - Cerrar este panel</li>
          <li><kbd>H</kbd> - Ir al inicio</li>
          <li><kbd>M</kbd> - Ir al menú principal</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Overlay para cerrar el panel -->
<div 
  class="accessibility-overlay"
  [class.show]="showAccessibilityPanel"
  (click)="toggleAccessibilityPanel()">
</div>
